import { render, staticRenderFns } from "./ConfigTOTPDialog.vue?vue&type=template&id=afe46268&scoped=true"
import script from "./ConfigTOTPDialog.vue?vue&type=script&lang=ts"
export * from "./ConfigTOTPDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfigTOTPDialog.vue?vue&type=style&index=0&id=afe46268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe46268",
  null
  
)

export default component.exports